import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { TabIndex } from './tabs.model';

export function getTabFromRoute(tabIndex: TabIndex) {
  return inject(ActivatedRoute).paramMap.pipe(
    map((params) => tabIndex[params.get('tab') ?? tabIndex[0]])
  );
}
